import React, { useState, useContext } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderArrowDown } from '@fortawesome/pro-solid-svg-icons';
import AppContext from '../../contexts/app-context';

import ApiServiceServerless from '../../xhr_libs';
import SmallerLoader from '../SmallerLoader';


export const PlugBulkDownloadbyAccount = (props) => {
  const { plug_account_id, credential_id, accountNumber, utilityProvider, organizationId, style } = props;

  const { showToast } = useContext(AppContext);

  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = () => {
    setIsLoading(true);


    ApiServiceServerless.post(
      'providers/download-bulk-pdfs',
      {
        method: 'account',
        account_id: plug_account_id,
        account_number: accountNumber,
        credential_id: credential_id,
        provider_name: utilityProvider
      },
      { authorization_id: organizationId }
    )
      .then(() => {
        showToast('success', 'Success', 'Gathering your bills now. Please allow a few minutes for download and then you will receive an email with a download link');
      })
      .catch((error) => {
        throw error;
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  return (
    <>
      {isLoading &&
        <SmallerLoader style={style} className='et-link' />
      }
      {!isLoading &&
        <FontAwesomeIcon
          style={style}
          icon={faFolderArrowDown}
          onClick={() => handleDownload()}
          className='et-link'
          title='Download Bill'
        />}
    </>
  )
}